import { createIcon } from './createIcon';

/**
 * Sliders rather than the conventional gear: at 16px a gear's teeth turn to
 * mush, while two tracks with handles stay legible — and it reads as
 * "adjustable settings" rather than "system internals".
 *
 * The handles are filled with the page background so the tracks read as
 * passing behind them rather than through them.
 */
export const SettingsIcon = createIcon({
  name: 'SettingsIcon',
  viewBox: '0 0 16 16',
  size: 16,
  children: (
    <>
      <path
        d="M2.5 5.5h11M2.5 10.5h11"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <circle
        cx="6"
        cy="5.5"
        r="1.75"
        fill="var(--bg-color-page)"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <circle
        cx="10.5"
        cy="10.5"
        r="1.75"
        fill="var(--bg-color-page)"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </>
  ),
});

export default SettingsIcon;
